import { render, staticRenderFns } from "./ReadMarker.vue?vue&type=template&id=3dc59e82&"
import script from "./ReadMarker.vue?vue&type=script&lang=js&"
export * from "./ReadMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports